import { get } from 'lodash-es';
import createCachedSelector from 're-reselect';

import { REFUND_ASSIST_VIEW_ID, VOIDED_VIEW_ID } from '../../../components/shipping-grid/views/view-id-constants';
import { emptyArray, emptyObject } from 'ui-components/default-props/empty';
import { GridConfigService } from '../../../services/grid-config-service';
import {
  baseColumnsDefaultConfigs,
  defaultColumnConfigurations,
  refundAssistColumnsDefaultConfigs,
  voidedColumnsDefaultConfigs,
} from '../../../store/shipments/grid/default-column-configuration';

const EMAIL_COLUMN_IDS = ['delivery-notification', 'shipment-email-notified'];

export const selectIsLoading = (state) => get(state, 'isLoading');
export const selectPage = (state) => get(state, 'page');
export const selectPageSize = (state) => get(state, 'pageSize');
export const selectTotalRecords = (state) => get(state, 'totalRecords');
export const selectTotalPages = (state) => get(state, 'totalPages');
export const selectViewStartingCount = (state) => get(state, 'viewStartingCount');
export const selectViewEndingCount = (state) => get(state, 'viewEndingCount');
export const selectUserGridConfigurations = (state) => get(state, 'userViewConfigurations', emptyObject);
export const selectSearchTerm = (state) => get(state, 'searchTerm');
export const selectCurrentPageFulfillmentIds = (state) => get(state, 'currentPageFulfillmentIds', emptyArray);

const mergeConfigurationsSelector = createCachedSelector(
  (viewConfiguration) => viewConfiguration,
  (_, __, ___, enableNewEmailExperience) => enableNewEmailExperience,
  (viewConfiguration, enableNewEmailExperience) => {
    let config = GridConfigService.mergeUserAndDefaultConfigs(viewConfiguration, defaultColumnConfigurations);
    if (enableNewEmailExperience) {
      const filtered = config.filter((col) => !EMAIL_COLUMN_IDS.includes(col.id));
      config = filtered.length === 0 ? emptyArray : filtered;
    }
    return GridConfigService.mergeUserAndDefaultConfigs(config, defaultColumnConfigurations);
  },
)((_, statusViewId, activeFilterViewId, enableNewEmailExperience) => `${statusViewId}_${activeFilterViewId}_${enableNewEmailExperience}`);

const selectCustomViewColumnConfiguration = (state) => get(state, 'customViewColumnConfiguration');

export const selectCurrentViewGridConfigOrDefault = (state, { activeFilterViewId, statusViewId, enableNewEmailExperience = false }) => {
  if (activeFilterViewId === 'custom') {
    const viewConfiguration = selectCustomViewColumnConfiguration(state);
    return mergeConfigurationsSelector(viewConfiguration, statusViewId, activeFilterViewId, enableNewEmailExperience);
  }

  const allGridConfigs = selectUserGridConfigurations(state);
  const { [activeFilterViewId]: configForView } = allGridConfigs[statusViewId] || {};

  if (!configForView) {
    if (statusViewId === REFUND_ASSIST_VIEW_ID) return refundAssistColumnsDefaultConfigs;
    if (statusViewId === VOIDED_VIEW_ID) return voidedColumnsDefaultConfigs;
    return baseColumnsDefaultConfigs;
  }

  return mergeConfigurationsSelector(configForView, statusViewId, activeFilterViewId, enableNewEmailExperience);
};

export const selectCurrentOrderByColumn = (state, { statusViewId, activeFilterViewId }) => {
  const gridConfig =
    selectCurrentViewGridConfigOrDefault(state, {
      statusViewId,
      activeFilterViewId,
    }) || emptyArray;

  return gridConfig.find((col) => !!col.sorted);
};

export const selectAmazonStatusUpdateByFulfillmentId = (state, props) => {
  const { fulfillmentId } = props;
  return state.amazonShipmentUpdates[fulfillmentId];
};
